import styled from '@emotion/styled';
import { AppBar, Box, Stack, Skeleton } from '@mui/material';

export const HeaderSkeletonWrapper = styled(AppBar)<{ isHome: boolean }>`
  box-shadow: none;
  width: ${({ isHome }) => (isHome ? 'calc(100% - 40px)' : '100%')};
  padding: 0 15px;
  background: #fff;
`;

export const HeaderSkeletonStack = styled(Stack)`
  padding: 5px 0;
  background: transparent;
  width: 100%;
`;

export const MenuIconSkeleton = styled(Skeleton)`
  border-radius: 4px;
`;

export const LogoSkeleton = styled(Skeleton)`
  border-radius: 4px;
`;

export const CartIconSkeleton = styled(Skeleton)`
  border-radius: 4px;
`;

export const HeaderActionGroupSkeleton = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
`;

